module.exports = __webpack_public_path__ + "img/744.8ff0c55b.jpg";